(() => {
  const dialog = document.getElementById('SteadiaOfferPopup');
  if (!dialog || !dialog.showModal || dialog.dataset.bound) return;
  dialog.dataset.bound = 'true';
  const storageKey = 'steadia:offer-popup:v1';
  const sessionKey = 'steadia:offer-popup:session:v1';
  const day = 86400000;
  const preview = dialog.dataset.review === 'true' && new URLSearchParams(location.search).get('steadia_popup_preview') === '1';
  let lastFocus;
  let opened = false;
  let revealed = false;
  let signupPending = false;
  let captchaActive = false;
  const read = () => {
    try { return JSON.parse(localStorage.getItem(storageKey) || '{}'); }
    catch { return {}; }
  };
  const save = (value) => {
    try { localStorage.setItem(storageKey, JSON.stringify(value)); }
    catch {}
  };
  const eligible = () => {
    const state = read();
    if (dialog.dataset.knownSubscriber === 'true' || state.joined || Number(state.until) > Date.now()) return false;
    try { if (sessionStorage.getItem(sessionKey)) return false; }
    catch {}
    return true;
  };
  const shop = () => {
    dialog.close();
    const offer = document.getElementById('steadia-offer');
    const bundle = offer?.querySelector('[data-qty="3"]');
    if (bundle) bundle.click();
    offer?.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
    bundle?.focus({ preventScroll: true });
  };
  const reveal = () => {
    if (revealed) return;
    revealed = true;
    dialog.querySelector('[data-popup-game]')?.setAttribute('hidden', '');
    dialog.querySelector('[data-popup-offer]')?.removeAttribute('hidden');
    dialog.querySelector('[data-popup-shop]').hidden = false;
    dialog.querySelector('[data-offer-note]').hidden = false;
    dialog.setAttribute('aria-labelledby', 'SteadiaPopupOfferTitle');
    dialog.querySelector('#SteadiaPopupEmail')?.focus({ preventScroll: true });
  };
  const prepareScratch = () => {
    const canvas = dialog.querySelector('canvas');
    const ctx = canvas?.getContext('2d');
    if (!ctx || canvas.dataset.drawn) return;
    canvas.dataset.drawn = 'true';
    const fill = ctx.createLinearGradient(0, 0, 600, 320);
    fill.addColorStop(0, '#d4ab62'); fill.addColorStop(.5, '#B8893B'); fill.addColorStop(1, '#9e702a');
    ctx.fillStyle = fill; ctx.fillRect(0, 0, 600, 320);
    ctx.strokeStyle = '#ffffff33'; ctx.lineWidth = 1;
    for (let i = -320; i < 700; i += 18) { ctx.beginPath(); ctx.moveTo(i, 0); ctx.lineTo(i + 320, 320); ctx.stroke(); }
    ctx.fillStyle = '#fff'; ctx.textAlign = 'center'; ctx.font = '700 58px "DM Sans", Arial'; ctx.fillText('✦', 300, 110);
    ctx.font = '700 35px "DM Sans", Arial'; ctx.fillText(canvas.dataset.scratchTitle, 300, 171);
    ctx.font = '400 21px "DM Sans", Arial'; ctx.fillText(canvas.dataset.scratchSubtitle, 300, 210);
    let down = false;
    let last;
    const erase = (event) => {
      if (!down || revealed) return;
      const rect = canvas.getBoundingClientRect();
      const point = { x: (event.clientX - rect.left) * 600 / rect.width, y: (event.clientY - rect.top) * 320 / rect.height };
      ctx.globalCompositeOperation = 'destination-out'; ctx.strokeStyle = '#000'; ctx.lineWidth = 76; ctx.lineCap = 'round';
      ctx.beginPath(); ctx.moveTo(last?.x ?? point.x, last?.y ?? point.y); ctx.lineTo(point.x, point.y); ctx.stroke(); last = point;
    };
    const finish = () => {
      down = false; last = undefined;
      const pixels = ctx.getImageData(0, 0, 600, 320).data;
      let clear = 0; let total = 0;
      for (let y = 12; y < 320; y += 20) for (let x = 12; x < 600; x += 20) { total++; if (pixels[(y * 600 + x) * 4 + 3] < 32) clear++; }
      if (clear / total >= .35) reveal();
    };
    canvas.addEventListener('pointerdown', (event) => { down = true; last = undefined; canvas.setPointerCapture(event.pointerId); erase(event); });
    canvas.addEventListener('pointermove', erase);
    canvas.addEventListener('pointerup', finish);
    canvas.addEventListener('pointercancel', finish);
  };
  const open = () => {
    lastFocus = document.activeElement;
    opened = true;
    if (!preview) { try { sessionStorage.setItem(sessionKey, 'shown'); } catch {} }
    dialog.showModal();
    document.body.classList.add('steadia-popup-open');
    prepareScratch();
  };
  dialog.querySelectorAll('[data-popup-close]').forEach((button) => button.addEventListener('click', () => dialog.close()));
  dialog.querySelector('[data-popup-shop]').addEventListener('click', shop);
  dialog.querySelector('[data-popup-reveal]')?.addEventListener('click', reveal);
  dialog.addEventListener('close', () => {
    document.body.classList.remove('steadia-popup-open');
    if (captchaActive) return;
    if (!preview && !read().joined) save({ until: Date.now() + Number(dialog.dataset.dismissDays) * day });
    if (lastFocus?.isConnected) lastFocus.focus({ preventScroll: true });
  });
  dialog.querySelector('button[type="submit"]')?.addEventListener('click', () => {
    signupPending = dialog.querySelector('form').checkValidity();
  });
  const captchaObserver = new MutationObserver(() => {
    if (!signupPending) return;
    const frame = document.querySelector('iframe[title="hCaptcha challenge"]');
    const container = frame?.parentElement?.parentElement;
    const style = container && getComputedStyle(container);
    const visible = !!container && style.visibility === 'visible' && style.display !== 'none' && Number(style.opacity) > 0 && frame.getBoundingClientRect().height > 0;
    if (visible && dialog.open) { captchaActive = true; dialog.close(); }
    else if (!visible && captchaActive) { captchaActive = false; signupPending = false; open(); }
  });
  captchaObserver.observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['style', 'aria-hidden'] });
  dialog.addEventListener('click', (event) => {
    if (event.target !== dialog) return;
    const rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
  });
  const signupReturn = new URLSearchParams(location.search).get('steadia_popup') === '1';
  const success = !!dialog.querySelector('[data-popup-success]');
  const error = !!dialog.querySelector('[data-popup-error]');
  if (signupReturn && (success || error)) {
    if (success) { save({ joined: true }); dialog.querySelector('[data-popup-shop]').hidden = false; }
    else { revealed = true; dialog.setAttribute('aria-labelledby', 'SteadiaPopupOfferTitle'); dialog.querySelector('[data-popup-shop]').hidden = false; dialog.querySelector('[data-offer-note]').hidden = false; }
    open();
    history.replaceState(null, '', location.pathname + (location.hash || ''));
    return;
  }
  if (preview) { open(); return; }
  if (!eligible()) return;
  let visibleTime = 0;
  const timer = setInterval(() => {
    if (opened || !eligible()) { clearInterval(timer); return; }
    if (document.hidden) return;
    visibleTime += 250;
    if (visibleTime < Number(dialog.dataset.delay)) return;
    if (document.activeElement?.matches('input,textarea,select') || document.querySelector('dialog[open],cart-drawer.active,header-drawer details[open]')) return;
    clearInterval(timer);
    open();
  }, 250);
})();
